import { getSessionStoragePartner } from 'utils/getSessionStoragePartner';

export const useReferFriend = () => {
  const partner = getSessionStoragePartner();
  const query = new URLSearchParams(partner?.replace('/', ''));
  const rafToken = query.get('bp_e');

  return {
    rafToken
  };
};
